// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2BL1g","emails":"CreateEditClinics_emails__AV23k","emailTagLabel":"CreateEditClinics_emailTagLabel__gEIDg"};